import { combineReducers } from 'redux'
import { reducer as allSetting } from './getSetting'
import { reducer as addSetting } from './addSetting'
import { reducer as editSetting } from './editSetting'

export default combineReducers({
    allSetting,
    addSetting,
    editSetting,
})
